import { Screen } from '@fans-fund-me/shared-comm-react-cosmos/fans-fund-me/home-screen';
import { useAuth } from '@fans-fund-me/shared-common-esm-authentication';
import { useForm } from '@mantine/form';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { checkUsername } from '../../api/profile.ts';
import { FORM_ERRORS } from '../../constants/form_errors.ts';

function Home() {
  const auth = useAuth();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const form = useForm({
    mode: 'uncontrolled',
    initialValues: {
      username: '',
    },
    validate: {
      username: (value) => (value.length < 2 ? FORM_ERRORS.USERNAME_LENGTH_VALIDATION : null),
    },
  });

  const handleSubmit = (values: typeof form.values) => {
    if (!auth.isLoggedIn) {
      setIsLoading(true);
      checkUsername(values.username)
        .then(() => {
          setIsLoading(false);
          localStorage.setItem('ffm_register_username', values.username.toLowerCase());
          navigate('/register/country');
        })
        .catch((error) => {
          setIsLoading(false);

          if (error.response.status === 409 || error.response.status === 400) {
            form.setErrors({
              username: error.response.data.fields?.find(
                (field: { fieldName: string; message: string }) => field.fieldName === 'username',
              )?.message,
            });
          } else {
            console.error('Error submitting register username form', JSON.stringify(error));
          }
        });
    } else {
      form.setErrors({ username: 'You must be logged out in order to create an account' });
    }
  };

  return (
    <Screen
      form={form}
      handleSubmit={handleSubmit}
      isLoading={isLoading}
      hero={{
        '1024': `https://fans-fund-me-core-static-site-${import.meta.env.VITE_ENVIRONMENT}.s3.eu-west-2.amazonaws.com/images/hero/hero1024.webp`,
        '1280': `https://fans-fund-me-core-static-site-${import.meta.env.VITE_ENVIRONMENT}.s3.eu-west-2.amazonaws.com/images/hero/hero1280.webp`,
        '1366': `https://fans-fund-me-core-static-site-${import.meta.env.VITE_ENVIRONMENT}.s3.eu-west-2.amazonaws.com/images/hero/hero1366.webp`,
        '1440': `https://fans-fund-me-core-static-site-${import.meta.env.VITE_ENVIRONMENT}.s3.eu-west-2.amazonaws.com/images/hero/hero1440.webp`,
        '1536': `https://fans-fund-me-core-static-site-${import.meta.env.VITE_ENVIRONMENT}.s3.eu-west-2.amazonaws.com/images/hero/hero1536.webp`,
        '1600': `https://fans-fund-me-core-static-site-${import.meta.env.VITE_ENVIRONMENT}.s3.eu-west-2.amazonaws.com/images/hero/hero1600.webp`,
        '1920': `https://fans-fund-me-core-static-site-${import.meta.env.VITE_ENVIRONMENT}.s3.eu-west-2.amazonaws.com/images/hero/hero1920.webp`,
        '2560': `https://fans-fund-me-core-static-site-${import.meta.env.VITE_ENVIRONMENT}.s3.eu-west-2.amazonaws.com/images/hero/hero2560.webp`,
        '320': `https://fans-fund-me-core-static-site-${import.meta.env.VITE_ENVIRONMENT}.s3.eu-west-2.amazonaws.com/images/hero/hero320.webp`,
        '360': `https://fans-fund-me-core-static-site-${import.meta.env.VITE_ENVIRONMENT}.s3.eu-west-2.amazonaws.com/images/hero/hero360.webp`,
        '375': `https://fans-fund-me-core-static-site-${import.meta.env.VITE_ENVIRONMENT}.s3.eu-west-2.amazonaws.com/images/hero/hero375.webp`,
        '3840': `https://fans-fund-me-core-static-site-${import.meta.env.VITE_ENVIRONMENT}.s3.eu-west-2.amazonaws.com/images/hero/hero3840.webp`,
        '390': `https://fans-fund-me-core-static-site-${import.meta.env.VITE_ENVIRONMENT}.s3.eu-west-2.amazonaws.com/images/hero/hero390.webp`,
        '393': `https://fans-fund-me-core-static-site-${import.meta.env.VITE_ENVIRONMENT}.s3.eu-west-2.amazonaws.com/images/hero/hero393.webp`,
        '412': `https://fans-fund-me-core-static-site-${import.meta.env.VITE_ENVIRONMENT}.s3.eu-west-2.amazonaws.com/images/hero/hero412.webp`,
        '414': `https://fans-fund-me-core-static-site-${import.meta.env.VITE_ENVIRONMENT}.s3.eu-west-2.amazonaws.com/images/hero/hero414.webp`,
        '601': `https://fans-fund-me-core-static-site-${import.meta.env.VITE_ENVIRONMENT}.s3.eu-west-2.amazonaws.com/images/hero/hero601.webp`,
        '640': `https://fans-fund-me-core-static-site-${import.meta.env.VITE_ENVIRONMENT}.s3.eu-west-2.amazonaws.com/images/hero/hero640.webp`,
        '768': `https://fans-fund-me-core-static-site-${import.meta.env.VITE_ENVIRONMENT}.s3.eu-west-2.amazonaws.com/images/hero/hero768.webp`,
        '800': `https://fans-fund-me-core-static-site-${import.meta.env.VITE_ENVIRONMENT}.s3.eu-west-2.amazonaws.com/images/hero/hero800.webp`,
        '810': `https://fans-fund-me-core-static-site-${import.meta.env.VITE_ENVIRONMENT}.s3.eu-west-2.amazonaws.com/images/hero/hero810.webp`,
        '820': `https://fans-fund-me-core-static-site-${import.meta.env.VITE_ENVIRONMENT}.s3.eu-west-2.amazonaws.com/images/hero/hero820.webp`,
        '828': `https://fans-fund-me-core-static-site-${import.meta.env.VITE_ENVIRONMENT}.s3.eu-west-2.amazonaws.com/images/hero/hero828.webp`,
      }}
      stripeLogo={{
        '1024': `https://fans-fund-me-core-static-site-${import.meta.env.VITE_ENVIRONMENT}.s3.eu-west-2.amazonaws.com/images/stripe-logo/stripe-logo1024.webp`,
        '1280': `https://fans-fund-me-core-static-site-${import.meta.env.VITE_ENVIRONMENT}.s3.eu-west-2.amazonaws.com/images/stripe-logo/stripe-logo1280.webp`,
        '1366': `https://fans-fund-me-core-static-site-${import.meta.env.VITE_ENVIRONMENT}.s3.eu-west-2.amazonaws.com/images/stripe-logo/stripe-logo1366.webp`,
        '1440': `https://fans-fund-me-core-static-site-${import.meta.env.VITE_ENVIRONMENT}.s3.eu-west-2.amazonaws.com/images/stripe-logo/stripe-logo1440.webp`,
        '1536': `https://fans-fund-me-core-static-site-${import.meta.env.VITE_ENVIRONMENT}.s3.eu-west-2.amazonaws.com/images/stripe-logo/stripe-logo1536.webp`,
        '1600': `https://fans-fund-me-core-static-site-${import.meta.env.VITE_ENVIRONMENT}.s3.eu-west-2.amazonaws.com/images/stripe-logo/stripe-logo1600.webp`,
        '1920': `https://fans-fund-me-core-static-site-${import.meta.env.VITE_ENVIRONMENT}.s3.eu-west-2.amazonaws.com/images/stripe-logo/stripe-logo1920.webp`,
        '2560': `https://fans-fund-me-core-static-site-${import.meta.env.VITE_ENVIRONMENT}.s3.eu-west-2.amazonaws.com/images/stripe-logo/stripe-logo2560.webp`,
        '320': `https://fans-fund-me-core-static-site-${import.meta.env.VITE_ENVIRONMENT}.s3.eu-west-2.amazonaws.com/images/stripe-logo/stripe-logo320.webp`,
        '360': `https://fans-fund-me-core-static-site-${import.meta.env.VITE_ENVIRONMENT}.s3.eu-west-2.amazonaws.com/images/stripe-logo/stripe-logo360.webp`,
        '375': `https://fans-fund-me-core-static-site-${import.meta.env.VITE_ENVIRONMENT}.s3.eu-west-2.amazonaws.com/images/stripe-logo/stripe-logo375.webp`,
        '3840': `https://fans-fund-me-core-static-site-${import.meta.env.VITE_ENVIRONMENT}.s3.eu-west-2.amazonaws.com/images/stripe-logo/stripe-logo3840.webp`,
        '390': `https://fans-fund-me-core-static-site-${import.meta.env.VITE_ENVIRONMENT}.s3.eu-west-2.amazonaws.com/images/stripe-logo/stripe-logo390.webp`,
        '393': `https://fans-fund-me-core-static-site-${import.meta.env.VITE_ENVIRONMENT}.s3.eu-west-2.amazonaws.com/images/stripe-logo/stripe-logo393.webp`,
        '412': `https://fans-fund-me-core-static-site-${import.meta.env.VITE_ENVIRONMENT}.s3.eu-west-2.amazonaws.com/images/stripe-logo/stripe-logo412.webp`,
        '414': `https://fans-fund-me-core-static-site-${import.meta.env.VITE_ENVIRONMENT}.s3.eu-west-2.amazonaws.com/images/stripe-logo/stripe-logo414.webp`,
        '601': `https://fans-fund-me-core-static-site-${import.meta.env.VITE_ENVIRONMENT}.s3.eu-west-2.amazonaws.com/images/stripe-logo/stripe-logo601.webp`,
        '640': `https://fans-fund-me-core-static-site-${import.meta.env.VITE_ENVIRONMENT}.s3.eu-west-2.amazonaws.com/images/stripe-logo/stripe-logo640.webp`,
        '768': `https://fans-fund-me-core-static-site-${import.meta.env.VITE_ENVIRONMENT}.s3.eu-west-2.amazonaws.com/images/stripe-logo/stripe-logo768.webp`,
        '800': `https://fans-fund-me-core-static-site-${import.meta.env.VITE_ENVIRONMENT}.s3.eu-west-2.amazonaws.com/images/stripe-logo/stripe-logo800.webp`,
        '810': `https://fans-fund-me-core-static-site-${import.meta.env.VITE_ENVIRONMENT}.s3.eu-west-2.amazonaws.com/images/stripe-logo/stripe-logo810.webp`,
        '820': `https://fans-fund-me-core-static-site-${import.meta.env.VITE_ENVIRONMENT}.s3.eu-west-2.amazonaws.com/images/stripe-logo/stripe-logo820.webp`,
        '828': `https://fans-fund-me-core-static-site-${import.meta.env.VITE_ENVIRONMENT}.s3.eu-west-2.amazonaws.com/images/stripe-logo/stripe-logo828.webp`,
      }}
    />
  );
}

export default Home;
